import { handleActions } from '../modules/helpers';
import { ActionTypes } from '../constants/index';

export const businessState = {
  // admin
  businesses: [],
  loadingBusinesses: false,
  loadingStatusUpdate: false,
  // business portal
  profile: null,
  loadingProfile: false,
  rewards: [],
  loadingRewards: false,
  loadingUpload: false,
  redemptions: null,
  loadingRedemptions: false,
  qr: null,
  loadingQr: false,
};

export default {
  business: handleActions(
    {
      // admin: get all businesses
      [ActionTypes.GET_BUSINESSES_REQUEST]: draft => {
        draft.loadingBusinesses = true;
      },
      [ActionTypes.GET_BUSINESSES_SUCCESS]: (draft, { payload }) => {
        draft.businesses = payload?.result ?? [];
        draft.loadingBusinesses = false;
      },
      [ActionTypes.GET_BUSINESSES_FAILURE]: draft => {
        draft.loadingBusinesses = false;
      },

      // admin: update business status
      [ActionTypes.UPDATE_BUSINESS_STATUS_REQUEST]: draft => {
        draft.loadingStatusUpdate = true;
      },
      [ActionTypes.UPDATE_BUSINESS_STATUS_SUCCESS]: draft => {
        draft.loadingStatusUpdate = false;
      },
      [ActionTypes.UPDATE_BUSINESS_STATUS_FAILURE]: draft => {
        draft.loadingStatusUpdate = false;
      },

      // business portal: get my profile
      [ActionTypes.GET_BUSINESS_ME_REQUEST]: draft => {
        draft.loadingProfile = true;
      },
      [ActionTypes.GET_BUSINESS_ME_SUCCESS]: (draft, { payload }) => {
        draft.profile = payload?.result ?? payload;
        draft.loadingProfile = false;
      },
      [ActionTypes.GET_BUSINESS_ME_FAILURE]: draft => {
        draft.loadingProfile = false;
      },

      // business portal: rewards
      [ActionTypes.GET_BUSINESS_REWARDS_REQUEST]: draft => {
        draft.loadingRewards = true;
      },
      [ActionTypes.GET_BUSINESS_REWARDS_SUCCESS]: (draft, { payload }) => {
        draft.rewards = payload?.result ?? [];
        draft.loadingRewards = false;
      },
      [ActionTypes.GET_BUSINESS_REWARDS_FAILURE]: draft => {
        draft.loadingRewards = false;
      },

      [ActionTypes.UPLOAD_BUSINESS_REWARDS_REQUEST]: draft => {
        draft.loadingUpload = true;
      },
      [ActionTypes.UPLOAD_BUSINESS_REWARDS_SUCCESS]: draft => {
        draft.loadingUpload = false;
      },
      [ActionTypes.UPLOAD_BUSINESS_REWARDS_FAILURE]: draft => {
        draft.loadingUpload = false;
      },

      [ActionTypes.DELETE_BUSINESS_REWARD_SUCCESS]: (draft, { payload: { rewardId } }) => {
        draft.rewards = draft.rewards.filter(r => r.id !== rewardId);
      },

      // business portal: redemptions
      [ActionTypes.GET_BUSINESS_REDEMPTIONS_REQUEST]: draft => {
        draft.loadingRedemptions = true;
      },
      [ActionTypes.GET_BUSINESS_REDEMPTIONS_SUCCESS]: (draft, { payload }) => {
        draft.redemptions = payload?.result ?? null;
        draft.loadingRedemptions = false;
      },
      [ActionTypes.GET_BUSINESS_REDEMPTIONS_FAILURE]: draft => {
        draft.loadingRedemptions = false;
      },

      // business portal: QR
      [ActionTypes.GET_BUSINESS_QR_REQUEST]: draft => {
        draft.loadingQr = true;
      },
      [ActionTypes.GET_BUSINESS_QR_SUCCESS]: (draft, { payload }) => {
        draft.qr = payload?.result ?? null;
        draft.loadingQr = false;
      },
      [ActionTypes.GET_BUSINESS_QR_FAILURE]: draft => {
        draft.loadingQr = false;
      },
    },
    businessState,
  ),
};
